import React from "react";
import { Button, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { jwtDecode } from "jwt-decode";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

const onFinish = async (values) => {
  try {
    dispatch(showLoading());
    const response = await axios.post("/api/user/login", values);
    dispatch(hideLoading());

    if (response.data.success) {
      toast.success(response.data.message);

      const token = response.data.data;
      localStorage.setItem("token", token);

      const decoded = jwtDecode(token);
 

 if (decoded.isAdmin)  navigate("/admin/home", { replace: true });
else if (decoded.isDoctor) navigate("/doctor", { replace: true });
 else if (decoded?.isStaff) navigate("/staff");
    else if (decoded?.regDoctor) navigate("/reg");
      else {
        navigate("/");
      }

    } else {
      toast.error(response.data.message);

      if (response.data.redirectTo) {
        toast("Redirecting to OTP Verification Page");
        setTimeout(() => navigate(response.data.redirectTo), 3000);
      }
    }
  } catch (error) {
    dispatch(hideLoading());
    toast.error("Something went wrong");
  }
};


  return (
    <div className="auth">
      <div className="auth-bg">
        <h1 className="card-t cn">Appointment Portal</h1><br></br>
        <div className="auth-form card p-3">
          <h3 className="card-title">Login to your Account</h3>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid Email Address!",
                },
                {
                  required: true,
                  message: "Please input your Email Address!",
                },
              ]}
            >
              <Input placeholder="Email Address " />
            </Form.Item>

            <Form.Item
              name="password"
              label="Passcode"
              rules={[
                {
                  required: true,
                  message: "Please input your passcode!",
                },
              ]}
            >
              <Input.Password 
              placeholder="Passcode"/>
            </Form.Item>

            <Button className="btn-primary mt-3" htmlType="submit">
              Login
            </Button>

            <div>
            <p className="mt-2 pm">
                Click here to - {" "}
                <Link to="/reset-password" className="anchor">
                  Reset Passcode
                </Link>
              </p>
              <p className="mt-2 pm">
                Register with Us - {" "}
                <Link to="/Register" className="anchor">
                  Click Here
                </Link>
              </p>
            </div>
          </Form>
            
        </div>
      </div>
    </div>
  );
}

export default Login;
